import { hasPermission } from '@/hooks/useBackendMenu'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { useNavigate, useParams } from 'react-router-dom'
import { trocaHorario } from 'service/api'
import { toast } from 'sonner'
import { FormTrocaDiaTrabalho } from '../forms/TrocaDiaTrabalho'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

export default function DetalhesTrocaDia() {
    const navigate = useNavigate()

    const params = useParams<{ id: string }>()

    const { data } = trocaHorario.diaTrabalho.useFetchById(params.id!, {
        onSuccess: troca => {
            if (!troca) navigate(-1)
        },
    })

    const { mutate, isLoading } = trocaHorario.diaTrabalho.mutations.useDelete({
        onSuccess: () => {
            invalidateDigitacaoQueries()
        },
    })

    const handleSubmit = () => {
        mutate(Number(params.id), {
            onSuccess: () => {
                toast.success('Troca de dia de trabalho removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover troca de dia de trabalho')
                }
            },
        })
    }

    if (!data) return null

    return (
        <Dialog.Root
            onSubmit={
                hasPermission(['delete', 'TrocaDeDiaDeTrabalho'])
                    ? handleSubmit
                    : undefined
            }
            loading={isLoading}
            defaultValues={{
                ...data,
            }}
            disableFields
        >
            <Dialog.Title action="Detalhes da troca de dia de trabalho">
                {data.Funcionario?.nome ?? ''} ·{' '}
                {dayjs.utc(data.trabalha).format('DD/MM/YYYY')}
            </Dialog.Title>
            <Dialog.Content>
                <FormTrocaDiaTrabalho disableSelects disabled />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Voltar
                </Dialog.Actions.SecondaryButton>
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
